/**
 * Initiates all our quantity spinners
 * 
 * @export
 * @class QuantitySpinners
 */
import { QuantitySpinner } from './quantity_spinner';

export class QuantitySelectors {

    constructor() {
        const spinners = document.querySelectorAll('.js-quantity-selector');
        if(spinners) {

            $.each(spinners, ({}, spinner) => {
                new QuantitySpinner(spinner as HTMLElement);
            });
        }
    }
}
